var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicksignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.076 7.68583C143.14 14.5255 152.706 17.0875 161.379 14.1965C174.353 9.8482 188.221 17.8631 190.947 31.2604C192.78 40.2155 199.785 47.2197 208.74 49.053C222.16 51.7795 230.152 65.6469 225.804 78.6211C222.913 87.2941 225.475 96.8603 232.314 102.924C242.562 111.997 242.562 128.003 232.314 137.076C225.475 143.14 222.913 152.706 225.804 161.379C230.152 174.353 222.137 188.221 208.74 190.947C199.785 192.78 192.78 199.785 190.947 208.74C188.221 222.16 174.353 230.152 161.379 225.804C152.706 222.913 143.14 225.475 137.076 232.314C128.003 242.562 111.997 242.562 102.924 232.314C96.8602 225.475 87.2941 222.913 78.6211 225.804C65.6468 230.152 51.7795 222.137 49.053 208.74C47.2197 199.785 40.2155 192.78 31.2604 190.947C17.8396 188.221 9.8482 174.353 14.1965 161.379C17.0875 152.706 14.5255 143.14 7.68583 137.076C-2.56194 128.003 -2.56194 111.997 7.68583 102.924C14.5255 96.8603 17.0875 87.2941 14.1965 78.6211C9.8482 65.6469 17.8631 51.7795 31.2604 49.053C40.2155 47.2197 47.2197 40.2155 49.053 31.2604C51.7795 17.8396 65.6468 9.8482 78.6211 14.1965C87.2941 17.0875 96.8602 14.5255 102.924 7.68583C111.997 -2.56194 128.003 -2.56194 137.076 7.68583Z",
    fill: "#20bfb2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.268 89.5413C174.835 93.003 174.92 98.7008 171.459 102.268L115.384 160.049C110.671 164.907 102.875 164.907 98.1612 160.049L67.0413 127.982C63.5797 124.415 63.6652 118.717 67.2322 115.256C70.7992 111.794 76.497 111.879 79.9587 115.446L106.773 143.077L158.541 89.7322C162.003 86.1652 167.701 86.0797 171.268 89.5413Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "",
    x1: 240,
    y1: 240,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20bfb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1DC5C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicksignup);
export default __webpack_public_path__ + "static/media/ticksignup.e3f4d1ea9c38e3947e3be83a07d2513d.svg";
export { ForwardRef as ReactComponent };